import { useQuery } from '@apollo/client';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import AdminTripFormFields from '@website/components/trips/edit/AdminTripFormFields';
import ErrorPage from '@website/components/utilities/ErrorPage';
import { TripDetailsForTripEditFormDocument } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';
import TripFormLayout from '../../../../components/trips/edit/TripFormLayout';
import LoadingPage from '../../../../components/utilities/LoadingPage';

export function AdminSettings({ query }) {
  const { tripUrl } = query;
  const baseUrl = `/trips/${tripUrl}/edit`;

  // Get the trip in question
  const { data, loading, error } = useQuery(
    TripDetailsForTripEditFormDocument,
    {
      variables: { urlSlug: tripUrl },
      fetchPolicy: 'cache-and-network',
    },
  );

  const trip = data?.tripByURL;

  if (loading || !trip) {
    return <LoadingPage />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <div>
      <TripFormLayout
        title={trip.title}
        baseUrl={baseUrl}
        tab="admin"
        tripUrl={tripUrl}
        host={trip.host}
      >
        <AdminTripFormFields trip={trip} />
      </TripFormLayout>
    </div>
  );
}

/**
 * Edit Trip Tab Page
 */
export default function AdminSettingsTab() {
  const { query } = useRouter();
  if (!query) return <LoadingPage />;

  return (
    <RequiresAuth>
      <AdminSettings query={query} />
    </RequiresAuth>
  );
}
